import React from 'react';
import { Link } from 'react-router-dom';
import { FileSignature } from 'lucide-react';
import LogoutButton from './LogoutButton';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const { user } = useAuth();

  return (
    <nav className="bg-white shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <FileSignature className="h-8 w-8 text-blue-600" />
            <span className="text-xl font-bold text-gray-900">SureSign</span>
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-600 hover:text-blue-600">Home</Link>
            {user ? (
              <>
                <Link to="/onboarding" className="text-gray-600 hover:text-blue-600">Student Onboarding</Link>
                <Link to="/register-property" className="text-gray-600 hover:text-blue-600">Property Onboarding</Link>
                {user.role !== 'student' && (
                  <Link to="/admin/dashboard" className="text-gray-600 hover:text-blue-600">Admin</Link>
                )}
                <Link to="/lease-agreement" className="text-gray-600 hover:text-blue-600">Lease</Link>
                <Link to="/invoice" className="text-gray-600 hover:text-blue-600">Invoice</Link>
                <LogoutButton />
              </>
            ) : (
              <Link 
                to="/login" 
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;